import { Fragment } from "react";

const Diamond = () => (
  <span className="mx-6 inline-block h-2.5 w-2.5 rotate-45 bg-gold align-middle sm:mx-10" aria-hidden="true" />
);

export default function Marquee({ items }) {
  const Row = ({ ariaHidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
      {items.map((t) => (
        <Fragment key={t}>
          <span className="font-display text-3xl tracking-[0.08em] text-bone/90 sm:text-5xl">{t}</span>
          <Diamond />
        </Fragment>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-white/10 bg-ink py-5 sm:py-6" data-testid="brand-marquee">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
